var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpansionStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 612,
    viewBox: "0 0 504 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.4 465.712V289.272H380.48V465.712H122.4Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.016 465.68H92V485.632H411.016V465.68Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.64 373.44H211.24V465.72H291.64V373.44Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8 253V301.24C92.8 323.28 110.664 341.144 132.704 341.144C154.744 341.144 172.608 323.28 172.608 301.24C172.608 323.28 190.472 341.144 212.512 341.144C234.552 341.144 252.416 323.28 252.416 301.24C252.432 323.28 270.304 341.136 292.344 341.12C314.368 341.104 332.208 323.256 332.224 301.24C332.24 323.28 350.112 341.136 372.152 341.12C394.176 341.104 412.016 323.256 412.032 301.24V253H92.8Z",
    fill: "#419AEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.776 202.336L92.7759 253H412L361 202.336H143.776Z",
    fill: "#0E4C86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252 0C216.654 0 188 28.6807 188 64.05C188 99.4239 252 183 252 183C252 183 316 99.4239 316 64.05C316 28.6807 287.346 0 252 0ZM252 96.075C243.513 96.075 235.374 92.7009 229.373 86.6951C223.371 80.6892 220 72.5436 220 64.05C220 55.5564 223.371 47.4108 229.373 41.4049C235.374 35.3991 243.513 32.025 252 32.025C260.487 32.025 268.626 35.3991 274.627 41.4049C280.629 47.4108 284 55.5564 284 64.05C284 72.5436 280.629 80.6892 274.627 86.6951C268.626 92.7009 260.487 96.075 252 96.075Z",
    fill: "#419AEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpansionStore);
export default __webpack_public_path__ + "static/media/expansionStore.0af7e899e8fa7b5462bcddf107d37578.svg";
export { ForwardRef as ReactComponent };